@if (!hasP00031()) {
  <app-larged-tuile
    icon="fa-kit fa-picto-eclairage"
    [title]="'dashboard.lighting' | translate"
    [buttons]="buttons"
    [status]="
      buttons[this.actionStack!.getValue('eclairageStandardSCommandeEclairage')]
        .title!
    "
    [statusMode]="
      buttons[this.actionStack!.getValue('eclairageStandardSCommandeEclairage')]
        .status!
    "
    [selectItem]="
      this.actionStack!.getValue('eclairageStandardCModeFonctionnement')
    "
    (onPressSetting)="this.openProductModal()"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Controle,
        'eclairageStandardCModeFonctionnement',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-larged-tuile>
}
